import { AxiosResponse } from 'axios'
import axios from '@/services/axios'
import type {
  PaymentMethodArenaPayload,
  PaymentMethodInterface,
} from '@/models/shop/PaymentMethod.types'

const SHOP_BASE_URI = process.env.VUE_APP_SHOP_V2_BASE_URI
const ENTITY = 'payment-methods'

export default abstract class PaymentMethodsApi {
  public static async list(): Promise<
    AxiosResponse<{
      data: PaymentMethodInterface[]
      metadata: { count: number; page: number; size: number; sort: string }
    }>
  > {
    const url = `${SHOP_BASE_URI}/${ENTITY}`
    return await axios.get(url)
  }

  public static async get(
    id: string,
  ): Promise<AxiosResponse<PaymentMethodInterface>> {
    const url = `${SHOP_BASE_URI}/${ENTITY}/${id}`
    return await axios.get(url)
  }

  public static async addPaymentMethodToArena(
    arenaId: string,
    data: PaymentMethodArenaPayload,
  ): Promise<AxiosResponse<PaymentMethodInterface>> {
    const url = `${SHOP_BASE_URI}/arenas/${arenaId}/${ENTITY}`
    return await axios.post(url, data)
  }

  public static async getArenaPaymentMethods(arenaId: string): Promise<
    AxiosResponse<{
      data: PaymentMethodInterface[]
      metadata: { count: number; page: number; size: number; sort: string }
    }>
  > {
    const url = `${SHOP_BASE_URI}/arenas/${arenaId}/${ENTITY}`
    return await axios.get(url)
  }

  public static async removePaymentMethodFromArena(
    arenaId: string,
    id: string,
  ): Promise<AxiosResponse<void>> {
    const url = `${SHOP_BASE_URI}/arenas/${arenaId}/${ENTITY}/${id}`
    return await axios.delete(url)
  }
}
